import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Button, EmptyState, Skeleton } from "@nexus/ui";
import { connectionsQueryOptions } from "@/lib/queries";
import { ConnectionCard } from "./ConnectionCard";

interface MyConnectionsTabProps {
  tenantId: string;
  onBrowseCatalog?: () => void;
}

export function MyConnectionsTab({ tenantId, onBrowseCatalog }: MyConnectionsTabProps) {
  const { t } = useTranslation();
  const { data: connections = [], isLoading } = useQuery(
    connectionsQueryOptions(tenantId),
  );

  if (isLoading) {
    return (
      <div className="flex flex-col gap-3">
        {Array.from({ length: 2 }).map((_, i) => (
          <Skeleton key={i} className="h-20 rounded-xl" />
        ))}
      </div>
    );
  }

  if (connections.length === 0) {
    return (
      <EmptyState
        icon="link"
        title={t("marketplace.connections.empty")}
        description={t("marketplace.connections.emptyDescription")}
        action={
          onBrowseCatalog ? (
            <Button type="button" onClick={onBrowseCatalog}>
              {t("marketplace.connections.emptyAction")}
            </Button>
          ) : undefined
        }
      />
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {connections.map((connection) => (
        <ConnectionCard key={connection.id} connection={connection} tenantId={tenantId} />
      ))}
    </div>
  );
}
